import { map, cloneDeep } from 'lodash-es';
import ItineraryTextTypes from '../../../variables/itineraryTextTypes';

export default {

  /**
   * @param state
   * @returns {Array}
   */
  mapItineraryOverview(state) {
    const overviewList = state.overview.items;
    const productTypes = state.productTypes.items;
    const countries = state.masterCountries.items || [];

    return map(overviewList, (item) => {
      const index = productTypes.findIndex(productType => productType.id === item.productTypeId);
      const productType = productTypes[index];
      const itineraryCountryIds = item.tripCountryIds || [];
      const itemCountries = countries.filter(
        country => itineraryCountryIds.indexOf(country.id.toString()) !== -1,
      );
      return { ...item, productType: productType.name || null, countries: itemCountries };
    });
  },

  /**
   * @param state
   * @returns {Array}
   */
  getAvailableItinerarySalesCountries(state) {
    const masterCountries = state.masterCountries.items || [];
    const selected = state.salesCountries.items || [];
    const selectedIds = selected.map(country => country.id);
    return masterCountries.filter(country => selectedIds.indexOf(country.id) === -1);
  },

  /**
   * @param state
   * @returns {Array}
   */
  getAvailableItineraryTripThemes(state) {
    const elcanoTripThemes = state.tripThemes.items || [];
    const selected = state.assignedTripThemes.items || [];
    const selectedIds = selected.map(tripTheme => tripTheme.id);
    return elcanoTripThemes.filter(tripTheme => selectedIds.indexOf(tripTheme.id) === -1);
  },

  /**
   * @param state
   * @returns {Array}
   */
  mapItineraryTripCountries(state) {
    const countries = state.masterCountries.items || [];
    const itineraryCountryIds = state.edit.item.tripCountryIds || [];

    return countries.filter(item => itineraryCountryIds.indexOf(item.id.toString()) !== -1);
  },

  /**
   * @param state
   * @returns {Array}
   */
  getAvailableDayProgramHotels(state) {
    const hotels = state.dayProgramHotel.hotelsByArea || [];
    const selectedHotels = state.dayProgramHotel.selectedHotels || [];
    const selectedIds = selectedHotels.map(hotel => hotel.id);
    return hotels.filter(hotel => selectedIds.indexOf(hotel.id) === -1);
  },

  /**
   * @param state
   * @returns {Array}
   */
  getMappedMatrixPrices(state) {
    const priceIntervals = state.priceIntervals.items;
    const matrixPrices = state.matrixPrices.items;
    const calculatedMatrixPrices = state.calculatedMatrixPrices.items;

    const prices = priceIntervals.map((priceInterval, priceIntervalIndex) => {
      let intervalPrices = matrixPrices.map(matrixPrice =>
        matrixPrice.prices.find(price => price.itineraryPriceIntervalId === priceInterval.id));
      intervalPrices = intervalPrices.map(price => ({
        ...price,
        calculatedPrice: 0,
      }));

      if (calculatedMatrixPrices.length) {
        intervalPrices = intervalPrices.map((intervalPrice, index) => {
          const calculatedPrice = calculatedMatrixPrices[priceIntervalIndex][index];
          return {
            ...intervalPrice,
            calculatedPrice: calculatedPrice.grossPrice,
          };
        });
      }

      return {
        arrivalFrom: priceInterval.arrivalFrom,
        arrivalTo: priceInterval.arrivalTo,
        bookingFrom: priceInterval.bookFrom,
        bookingTo: priceInterval.bookTo,
        prices: intervalPrices,
      };
    });

    return prices;
  },

  mainItineraryText(state) {
    const itineraryTexts = cloneDeep(state.itineraryTexts.items);
    const mainText = itineraryTexts.findIndex(itineraryText => itineraryText.type === 'main');

    if (mainText !== -1) {
      return {
        ...itineraryTexts[mainText],
        index: mainText,
      };
    }

    return {
      index: null,
      type: ItineraryTextTypes.MAIN,
      text: '',
    };
  },

  generalItineraryTexts(state) {
    const itineraryTexts = cloneDeep(state.itineraryTexts.items);
    const generalTexts = itineraryTexts.filter(itineraryText => itineraryText.type === 'general');

    if (generalTexts.length) {
      return generalTexts.map((generalText, index) => ({
        ...generalText,
        index,
      }));
    }

    return [{
      index: null,
      type: ItineraryTextTypes.GENERAL,
      text: '',
    }];
  },

  importantItineraryTexts(state) {
    const itineraryTexts = cloneDeep(state.itineraryTexts.items);
    const importantTexts = itineraryTexts.filter(itineraryText => itineraryText.type === 'important');

    if (importantTexts.length) {
      return importantTexts.map((importantText, index) => ({
        ...importantText,
        index,
      }));
    }

    return [{
      index: null,
      type: ItineraryTextTypes.IMPORTANT,
      text: '',
    }];
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/itinerary/getters.js